import { isAfter, now, parseToDateTime } from '@calendly/datetime';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import { IconAlertTriangleFilled } from '@calendly/ui/components/glyphs/IconAlertTriangleFilled';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { forwardRef } from 'react';
const canceledBannerCss = "cjrc7so";
const isEventEndInPast = event => {
  if (!event.endTime) return false;
  const end = parseToDateTime(event.endTime);
  if (!end?.isValid) return false;
  return isAfter(now(), end) === true;
};
const CanceledBanner = ({
  cancellation
}) => <ContextualBanner variant="danger" className={canceledBannerCss}>
    <p><strong>{cancellation.attribution}</strong></p>
    <p>{cancellation.reason}</p>
  </ContextualBanner>;
const RescheduledBanner = ({
  cancellation
}) => <ContextualBanner variant="standard">
    <p><strong>{I18n.t('publisher.meetings.info_banner.rescheduled_by', {
        name: cancellation.cancelledBy
      })}</strong></p>
    <p>{cancellation.reason.replace(I18n.t('publisher.dashboard.event.rescheduled_prefix'), '')}</p>
  </ContextualBanner>;
const LocationErrorBannerIcon = forwardRef((props, ref) => <UiIcon ref={ref} icon={IconAlertTriangleFilled} size="small" {...props} />);
const LocationErrorBanner = ({
  externalLocation
}) => <ContextualBanner variant="danger" icon={LocationErrorBannerIcon}>
    <strong>{I18n.t('publisher.meetings.info_banner.action_needed')}</strong>
    {': '}
    {HtmlParser(externalLocation.errorNotice)}
  </ContextualBanner>;
export const InfoBanner = ({
  event
}) => {
  const {
    cancelled,
    newSchedulable,
    externalLocation,
    cancellation
  } = event;
  const isCancelled = cancelled && cancellation;
  const isRescheduled = isCancelled && !!newSchedulable;
  const hasLocationError = externalLocation?.showLocationIssue;
  if (isCancelled && !isRescheduled) {
    return <CanceledBanner cancellation={cancellation} />;
  }
  if (isRescheduled) {
    return <RescheduledBanner cancellation={cancellation} />;
  }
  if (hasLocationError && !isEventEndInPast(event)) {
    return <LocationErrorBanner externalLocation={externalLocation} />;
  }
  return null;
};

require("./info_banner.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./info_banner.js");